import { actionTypes } from 'BASE/store/types';
import chatUtil from 'BASE/common/chat/chat.util';
import chatConstant from 'BASE/common/chat/chat.constant';
import CONSTANT from 'BASE/common/chat/chat.constant'
import marquee_component from 'TY/views/Marquee'
import downLoadCenterAndAFK_component from 'TY/views/Download/DownLoadCenterAndAFK';
import switchUrl_component from 'TY/views/SpeedTest/SwitchUrl';
import userFeedback_component from 'TY/views/Feedback';
import GoExternalGame from 'BASE/components/externalGame/externalGame.go.component';
import audiovisual from 'BASE/components/audiovisual/audiovisual.component';
import * as gameData from 'BASE/common/lotteryGameData';
import * as gameMenu from 'BASE/common/menu/menu.game';
import lotteryConstant from 'BASE/common/lotteryConstant';

export default {
    data: function () {
        return {
            activedTab: undefined,
            gameMenus: {},
            vrMenus: {},
        };
    },
    mixins: [GoExternalGame,audiovisual],
    computed: {
        gameDatas() {
            return this.$store.state.lottoinfo.data;
        },
        isAgent() {
            return this.$store.state.userinfo.isAgent;
        },
        isTransferPointEnabled() {
            return this.$store.state.userinfo.privileges.isTransferPointEnabled;
        },
        userName() {
            return this.$store.state.userinfo.userName;
        },
        walletAmount() {
            return this.$store.state.userinfo.walletAmount;
        },
        systemRoomUnreadCount() {
            if (this.$store.state.chat) {
                let _room = this.$store.state.chat.rooms.find((item) => item.type === CONSTANT.roomType.SYSTEM);
                if (_room)
                    return _room.unreadCount;
            }

            return 0;
        },
        customerServiceRoomUnreadCount() {
            if (this.$store.state.chat) {
                let _room = this.$store.state.chat.rooms.find((item) => item.type === CONSTANT.roomType.CUSTOMER_SERVICE);
                if (_room)
                    return _room.unreadCount;
            }

            return 0;
        },
        announcementUnreadCount() {
            return this.$store.state.userinfo.unreadAnnouncement;
        },
        topMenu() {
            return gameMenu.mergeInfo(this.gameMenus.homeTop, [this.gameDatas]);   //目前後台menu名固定
        },
        hideWalletAmount() {
            return this.$store.state.userinfo.hideWalletAmount;
        },
        audioMuted() {
            return this.$store.state.userinfo.audioMuted;
        },
        vipInfo() {
            return this.$store.state.userinfo.vipinfo;
        }
    },
    components: {
        marquee_component,
        downLoadCenterAndAFK_component,
        switchUrl_component,
        userFeedback_component,
    },
    methods: {
        clickTab(newTab) {
            if (newTab === this.activedTab) {
                return;
            }
            this.activedTab = newTab;
        },
        closeTab() {
            this.activedTab = undefined;
        },
        async refreshAmount() {
            await this.$store.dispatch(actionTypes.USER_INFO_WALLET_AMOUNT);
        },
        openCustomerServiceChat() {
            if (this.$store.state.chat && this.$store.state.chat.userId) {
                let _roomId = chatUtil.getRoomId(chatConstant.serverRoomType.CUSTOMER_SERVICE, this.$store.state.chat.userId);
                this.$store.dispatch(actionTypes.CHAT_OPEN_ROOM_WINDOW, {
                    roomId: _roomId
                });
            }
        },
        openSystemChat() {
            if (this.$store.state.chat && this.$store.state.chat.userId) {
                let _roomId = chatUtil.getRoomId(chatConstant.serverRoomType.SYSTEM, this.$store.state.chat.userId);
                this.$store.dispatch(actionTypes.CHAT_OPEN_ROOM_WINDOW, {
                    roomId: _roomId
                });
            }
        },
        showAnnouncement(id, index) {
            if (this.$parent && this.$parent.showAnnouncement) {
                this.$parent.showAnnouncement(id, index);
            }
        },
        showSwitchUrl() {
            let _this = this;
            let _dialog = _this.$dialog.get('SwitchUrl');
            if (_this.$refs && _this.$refs.SwitchUrlRetest) {
                _this.$refs.SwitchUrlRetest.retest();
            }
            _dialog.show();

            _dialog.$on('close', function () {
                _dialog.hide();
            });
        },
        showFeedback() {
            if (this.$refs && this.$refs.Feedback) {
                this.$refs.Feedback.showFeedback();
            }
        },
        switchHideWalletAmount() {
            let _hideWalletAmount = !this.hideWalletAmount;
            this.$store.dispatch(actionTypes.USER_INFO_HIDE_WALLET_AMOUNT, { hideWalletAmount: _hideWalletAmount });
        },
        switchAudioMuted() {
            let _audioMuted = !this.audioMuted;
            this.$store.dispatch(actionTypes.USER_INFO_AUDIO_MUTED, { audioMuted: _audioMuted });
        }
    },
    updated() {
        //等所有Vue的資料更新完才做綁定，彩票遊戲選單是動態產生
        let _this = this;
        $(".topMenuItem").unbind().click(function () {
            _this.closeTab();
        });
    },
    async mounted() {
        try {
            this.gameMenus = await gameMenu.get();
            // 取得VR彩票
            this.vrMenus = await this.getVRLottery();
        } catch (err) {
            this.$dialog.warning('加载失败');
        }
    }
};